import React from 'react';

import { TermsOfServiceWebPage } from '../web/TermsOfServiceWebPage';

/** Auth yığında Kullanım Koşulları (EULA) tam metin. */
export function TermsOfServiceScreen() {
  return <TermsOfServiceWebPage showHomeLink={false} />;
}
